import { useEffect, useState } from 'react';

/**
 * Tracks the OS-level `prefers-reduced-motion` setting, so a component can drop
 * its transition rather than animate for someone who asked not to be animated at.
 *
 * Starts `false` and corrects in an effect: `matchMedia` is unavailable during
 * SSR and in some test environments, and defaulting to "reduced" there would
 * strip transitions for everyone whose first paint happens before the effect runs.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const onChange = () => setReduced(mq.matches);
    mq.addEventListener?.('change', onChange);
    return () => mq.removeEventListener?.('change', onChange);
  }, []);
  return reduced;
}
